<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        offset-md="2"
        md="8"
        offset-lg="3"
        lg="6"
      >
        <b-card class="text-center">
          <div class="my-5">
            <div v-if="paymentStatus === null">
              <feather-icon
                icon="ClockIcon"
                size="130"
                class="text-primary mb-3"
              />
              <div class="font-medium-4">
                {{ $t('customer.settlements.payment-status.waiting') }}
              </div>
              <b-alert
                v-if="longerThan30s"
                show
                class="font-medium-2 mt-3 p-2"
              >
                {{ $t('customer.settlements.payment-status.too-long') }}
              </b-alert>
              <b-progress
                v-else
                height="1.5rem"
                animated
                :value="progressValue"
                variant="success"
                class="progress-bar-success countdown-bar mt-3"
              />
            </div>
            <div v-else-if="paymentStatus === true">
              <feather-icon
                icon="CheckIcon"
                size="130"
                class="text-success mb-3"
              />
              <div class="font-medium-4">
                {{ $t('customer.settlements.payment-status.success') }}
              </div>
            </div>
            <div v-else>
              <feather-icon
                icon="AlertCircleIcon"
                size="130"
                class="text-danger mb-3"
              />
              <div class="font-medium-4">
                {{ $t('customer.settlements.payment-status.problem') }}
              </div>
            </div>
            <b-button
              size="lg"
              variant="primary"
              class="mt-3"
              :to="{name: 'customer-settlements'}"
            >
              {{ $t('customer.settlements.payment-status.btn-back') }}
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import paymentStatusSetup from '@/views/customer/settlements/payment/paymentStatusSetup'

export default {
  name: 'PaymentStatus',
  beforeDestroy() {
    clearInterval(this.interval)
  },
  setup: paymentStatusSetup,
}
</script>

<style lang="scss">
.feather-clock {
  animation: pulse 2s linear infinite;
}
.countdown-bar {
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  > .progress-bar {
    -webkit-transition: width 30.0s linear !important;
    -moz-transition: width 30.0s linear !important;
    -o-transition: width 30.0s linear !important;
    transition: width 30.0s linear !important;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.03, 1.03);
  }
  100% {
    transform: scale(1, 1);
  };
}
</style>
